import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { base_url } from '../../../api/api-url';
import { getAuthHeaders } from '../../../utility/getAuthHeaders';


export const fetchClients = createAsyncThunk('clients/fetch', async () => {
  const response = await axios.get(`${base_url}/client`, getAuthHeaders());
  return response.data.data;
});

export const addClient = createAsyncThunk('clients/add', async (clientData, { dispatch }) => {
  try {
    await axios.post(`${base_url}/client`, clientData, getAuthHeaders());
  } catch (err) {
    throw new Error(err.response?.data?.message || err.message);
  }
  dispatch(fetchClients());
});

export const updateClient = createAsyncThunk('clients/update', async ({ id, data }, { dispatch }) => {
  try {
    await axios.put(`${base_url}/client/${id}`, data, getAuthHeaders());
  } catch (err) {
    throw new Error(err.response?.data?.message || err.message);
  }
  dispatch(fetchClients());
});

export const deleteClient = createAsyncThunk('clients/delete', async (id, { dispatch }) => {
  await axios.delete(`${base_url}/client/${id}`, getAuthHeaders());
  dispatch(fetchClients());
});

const clientSlice = createSlice({
  name: 'clients',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
}); 

export default clientSlice.reducer;
